/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_nav_type_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate a signature from your name`)
};

const es_sig_nav_type_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera una firma a partir de tu nombre`)
};

const de_sig_nav_type_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generieren Sie eine Signatur aus Ihrem Namen`)
};

const nl_sig_nav_type_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereer een handtekening van uw naam`)
};

const fr_sig_nav_type_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer une signature à partir de votre nom`)
};

const it_sig_nav_type_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera una firma dal tuo nome`)
};

const pt_br2_sig_nav_type_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gere uma assinatura a partir do seu nome`)
};

const pt_sig_nav_type_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gere uma assinatura a partir do seu nome`)
};

const ja_sig_nav_type_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前から署名を生成`)
};

const zh_sig_nav_type_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从您的名字生成签名`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_nav_type_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_nav_type_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_nav_type_desc", locale)
	if (locale === "en") return en_sig_nav_type_desc(inputs)
	if (locale === "es") return es_sig_nav_type_desc(inputs)
	if (locale === "de") return de_sig_nav_type_desc(inputs)
	if (locale === "nl") return nl_sig_nav_type_desc(inputs)
	if (locale === "fr") return fr_sig_nav_type_desc(inputs)
	if (locale === "it") return it_sig_nav_type_desc(inputs)
	if (locale === "pt-BR") return pt_br2_sig_nav_type_desc(inputs)
	if (locale === "pt") return pt_sig_nav_type_desc(inputs)
	if (locale === "ja") return ja_sig_nav_type_desc(inputs)
	return zh_sig_nav_type_desc(inputs)
};